/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-06-25 09:39:52
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-15 16:34:39
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\monthly_terminal_performance_report\scanDetail\detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        mainId: this.paramsProps.mainId,
      },
    };
  },
  methods: {
    setColumn(col) {
      const item = col;
      if (item.field === 'checkTypeseq') {
        item.title = '序号';
        item.width = '50';
      }
      return item;
    },
  },
  created() {
    this.getConfigList('scan-list');
  },
};
